<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16H9AIw/tc-custom/9781626815117.jpg?1703670066829" alt="This image is the cover for the book Britt Montero Series, The Britt Montero Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Britt Montero Series, The Britt Montero Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>In one volume, the first five novels in the “irresistible series” starring a Miami crime reporter, from an Edgar Award–nominated author (<i>Kirkus Reviews</i>).</b><br/>  <br/> Being a crime reporter amid the sun and sin of Miami is a full-time job, one that Cuban-born Britt Montero does better than anyone else. But when you get that close to the criminal underworld, things have a way of sucking you in. In these five novels of suspense, <i>New York Times</i>–bestselling author and Pulitzer Prize–winning reporter Edna Buchanan sets her heroine loose on some of the most highly charged crimes in Miami, and reminds readers that you don’t necessarily have to live to make the front page . . .<br/>  <br/> Includes: <i>Contents Under Pressure</i>; <i>Miami, It’s Murder</i>; <i>Suitable for Framing</i>; <i>Act of Betrayal</i>; <i>Margin of Error</i><br/>  <br/> “[An] extremely likable heroine.” —<i>Publishers Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Edna  Buchanan
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?23789411